export default __webpack_public_path__ + "static/media/Referral_program.ebc2accf.svg";